module.exports = __webpack_public_path__ + "static/media/sombra-lombada-interna.0479fc8d.svg";